import axios from '@/utils/axiosHelper'

// 初始化数据
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/qy/dragon/init', method: 'get', params }, { interceptResultCode: false })
}

export const getUrl = (params) => {
  return axios({ url: '/qy/dragon/url', method: 'get', params }, { interceptResultCode: false })
}

export const getNum = (params) => {
  return axios({ url: '/qy/dragon/num', method: 'get', params }, { interceptResultCode: false })
}

export const lottery = (params) => {
  return axios({ url: '/qy/dragon/draw', method: 'post', params }, { interceptResultCode: false, timeout: 5000 })
}

export const onSubmitAddress = (params) => {
  return axios({ url: '/qy/dragon/address', method: 'post', params }, { interceptResultCode: false })
}

export const logout = (params) => {
  return axios({ url: '/login/free/loginout', method: 'post', params }, { interceptResultCode: false })
}

export const addNum = (params) => {
  return axios({ url: '/qy/dragon/day/goto', method: 'get', params }, { interceptResultCode: false })
}




// WEBPACK FOOTER //
// ./src/pages/qingyu/duanwu2023/api.js